const featuresComponents = import.meta.glob('../features/**/*.jsx', { eager: true });
const sharedComponents = import.meta.glob('../components/**/*.jsx', { eager: true });

export const loadComponent = (componentName) => {
  // Try loading from features first
  let componentPath = `../features/${componentName}.jsx`;
  let component = featuresComponents[componentPath];
  
  // If not found, try loading from components
  if (!component) {
    componentPath = `../components/${componentName}.jsx`;
    component = sharedComponents[componentPath];
  }
  
  if (!component) {
    throw new Error(`Component ${componentName} not found`);
  }
  return component.default;
};